import React from 'react';

import { AutocompleteForm } from './AutocompleteForm';
import { AutocompleteTagForm } from './AutocompleteTagForm';
import { ButtonGroupForm } from './ButtonGroupForm';
import { CheckboxForm } from './CheckboxForm';
import { DropdownForm } from './DropdownForm';
import { FormType } from './forms.enums';
import { Form } from './forms.types';
import { InputForm } from './InputForm';
import { MonthYearPeriodForm } from './month-year-period-form';
import { MonthDatePickerForm } from './MonthDatePickerForm';
import { TextAreaForm } from './TextAreaForm';
import { YesNoForm } from './YesNoForm';

export const FormItemFactory = ({ form }: { form: Form }): React.ReactElement | null => {
  switch (form.formType) {
    case FormType.YES_NO:
      return <YesNoForm form={form} />;
    case FormType.TEXT_AREA:
      return <TextAreaForm form={form} />;
    case FormType.INPUT:
      return <InputForm form={form} />;
    case FormType.CHECKBOXES:
      return <CheckboxForm form={form} />;
    case FormType.DROPDOWN:
      return <DropdownForm form={form} />;
    case FormType.AUTOCOMPLETE:
      return <AutocompleteForm form={form} />;
    case FormType.AUTOCOMPLETE_TAG:
      return <AutocompleteTagForm form={form} />;
    case FormType.MONTH_DATE_PICKER:
      return <MonthDatePickerForm form={form} />;
    case FormType.MONTH_YEAR_PERIOD:
      return <MonthYearPeriodForm form={form} />;
    case FormType.BUTTON_GROUP:
      return <ButtonGroupForm form={form} />;
    default:
      return null;
  }
};
